import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Accordion,
  Breadcrumb,
  Button,
  Dimmer,
  Dropdown,
  Form,
  Grid,
  Header,
  Icon,
  Loader,
  Modal,
  Segment,
  Table,
} from 'semantic-ui-react';
import useApiIntranet from '../../hooks/useApiIntranet';
import GraficoProcessosPorSituacao from './components/GraficoProcessosPorSituacao';
import GraficoProcessosPorArea from './components/GraficoProcessosPorArea';
import GraficoProcessosPorObjeto from './components/GraficoProcessosPorObjeto';
import GraficoProcessosPorResponsavel from './components/GraficoProcessosPorResponsavel';
import GraficoProcessosPorRegional from './components/GraficoProcessosPorRegional';
import GraficoProcessosPorMes from './components/GraficoProcessosPorMes';
import TabelaProcessos from './components/TabelaProcessos';
import { voltarOuDashboard } from '../../utils/navegacao';

function Juridico() {
  const navigate = useNavigate();

  // Calcular datas padrão
  const getDatasPadrao = () => {
    const hoje = new Date();
    const dataFim = hoje.toISOString().split('T')[0];
    
    const dozesMesesAtras = new Date();
    dozesMesesAtras.setMonth(dozesMesesAtras.getMonth() - 12);
    dozesMesesAtras.setDate(1); // Primeiro dia do mês
    const dataInicio = dozesMesesAtras.toISOString().split('T')[0];
    
    return { dataInicio, dataFim };
  };

  const { dataInicio: dataInicialPadrao, dataFim: dataFimPadrao } = getDatasPadrao();

  const { 
    data, 
    isLoading, 
    getProcessos,
    getSituacoesProcesso,
    getTrabalhadorJuridicos,
    getAreasDireito,
    getRegionaisProcessos,
    situacoes,
    trabalhadores,
    areas,
    regionais,
  } = useApiIntranet();
  const [activeIndex, setActiveIndex] = useState(-1); // Colapsado por padrão
  const [page, setPage] = useState(1);
  const [modalExpandirAberto, setModalExpandirAberto] = useState(false);
  const [dadosExpandir, setDadosExpandir] = useState([]);
  const [tituloExpandir, setTituloExpandir] = useState('');

  // Filtros
  const [filtroArea, setFiltroArea] = useState('');
  const [filtroResponsavel, setFiltroResponsavel] = useState('');
  const [filtroSituacao, setFiltroSituacao] = useState(''); // Padrão: Todas
  const [filtroParteNome, setFiltroParteNome] = useState('');
  const [filtroRegional, setFiltroRegional] = useState('');
  const [filtroDataAberturaInicio, setFiltroDataAberturaInicio] = useState(dataInicialPadrao);
  const [filtroDataAberturaFim, setFiltroDataAberturaFim] = useState(dataFimPadrao);

  // Construir opções dos dropdowns a partir dos dados da API
  const areasOptions = [
    { key: '', text: 'Todas as áreas', value: '' },
    ...areas.map(a => ({
      key: String(a.id),
      text: a.descricao,
      value: String(a.id)
    }))
  ];

  const situacoesOptions = [
    { key: '', text: 'Todas', value: '' },
    ...situacoes.map(s => ({
      key: String(s.id),
      text: s.descricao,
      value: String(s.id)
    }))
  ];

  const responsaveisOptions = [
    { key: '', text: 'Todos', value: '' },
    ...trabalhadores.map(t => ({
      key: String(t.pessoaFisica.id),
      text: t.pessoaFisica.nome,
      value: String(t.pessoaFisica.id)
    }))
  ];

  const regionaisOptions = [
    { key: '', text: 'Todas as regionais', value: '' },
    ...(Array.isArray(regionais) ? regionais : []).map(r => ({
      key: String(r.id),
      text: r.descricao,
      value: String(r.id)
    }))
  ];

  const handleAccordionClick = () => {
    setActiveIndex(activeIndex === 0 ? -1 : 0);
  };

  const buscar = () => {
    const filtros = { page: 1 };
    if (filtroArea) filtros.area = filtroArea;
    if (filtroResponsavel) filtros.responsavel = filtroResponsavel;
    if (filtroSituacao) filtros.situacao = filtroSituacao;
    if (filtroParteNome) filtros.parteNome = filtroParteNome;
    if (filtroRegional) filtros.regional = filtroRegional;
    if (filtroDataAberturaInicio) filtros.dataAberturaInicio = filtroDataAberturaInicio;
    if (filtroDataAberturaFim) filtros.dataAberturaFim = filtroDataAberturaFim;
    setPage(1);
    getProcessos(filtros);
  };

  const limpar = () => {
    const { dataInicio, dataFim } = getDatasPadrao();
    setFiltroArea('');
    setFiltroResponsavel('');
    setFiltroSituacao(''); // Todas
    setFiltroParteNome('');
    setFiltroRegional('');
    setFiltroDataAberturaInicio(dataInicio);
    setFiltroDataAberturaFim(dataFim);
    setPage(1);
    getProcessos({ 
      page: 1, 
      dataAberturaInicio: dataInicio,
      dataAberturaFim: dataFim 
    });
  };

  const handlePageChange = (novaPagina) => {
    const filtros = { page: novaPagina };
    if (filtroArea) filtros.area = filtroArea;
    if (filtroResponsavel) filtros.responsavel = filtroResponsavel;
    if (filtroSituacao) filtros.situacao = filtroSituacao;
    if (filtroParteNome) filtros.parteNome = filtroParteNome;
    if (filtroRegional) filtros.regional = filtroRegional;
    if (filtroDataAberturaInicio) filtros.dataAberturaInicio = filtroDataAberturaInicio;
    if (filtroDataAberturaFim) filtros.dataAberturaFim = filtroDataAberturaFim;
    setPage(novaPagina);
    getProcessos(filtros);
  };

  const abrirExpandir = (dados, titulo) => {
    setDadosExpandir(dados);
    setTituloExpandir(titulo);
    setModalExpandirAberto(true);
  };

  const fecharExpandir = () => {
    setModalExpandirAberto(false);
    setDadosExpandir([]);
    setTituloExpandir('');
  };

  // Busca inicial ao montar
  useEffect(() => {
    // Carrega as opções dos dropdowns
    getSituacoesProcesso();
    getTrabalhadorJuridicos();
    getAreasDireito();
    getRegionaisProcessos();
    
    // Carrega os processos com filtro padrão (12 meses)
    getProcessos({ 
      page: 1, 
      dataAberturaInicio: dataInicialPadrao,
      dataAberturaFim: dataFimPadrao 
    });
  }, [getProcessos, getSituacoesProcesso, getTrabalhadorJuridicos, getAreasDireito, getRegionaisProcessos, dataInicialPadrao, dataFimPadrao]);

  const totais = data?.data?.totais || {};
  const processos = data?.data?.processos || [];
  const meta = data?.data?.meta || {};

  return (
    <>
      {/* Cabeçalho */}
      <div className="clearfix">
        <Header as="h3" style={{ float: 'left' }}>
          Relatório Gerencial - Processos
          {meta.total > 0 && (
            <Header.Subheader style={{ display: 'inline', marginLeft: '1rem' }}>
              {new Intl.NumberFormat().format(meta.total)} processos
            </Header.Subheader>
          )}
        </Header>
        <div className="breadcrumb-com-voltar">
          <Button basic size="small" onClick={() => voltarOuDashboard(navigate)}>
            Voltar
          </Button>
          <Breadcrumb>
            <Breadcrumb.Section to="/" link as={Link}>
              Home
            </Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section active>Jurídico</Breadcrumb.Section>
          </Breadcrumb>
        </div>
      </div>

      {/* Filtros Compactos */}
      <Accordion fluid style={{ marginBottom: '1rem' }}>
        <Accordion.Title
          active={activeIndex === 0}
          index={0}
          onClick={handleAccordionClick}
          style={{ padding: '0.5rem 0' }}
        >
          <Icon name="dropdown" />
          <Icon name="filter" /> Filtros
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 0}>
          <Form>
            <Form.Group widths="equal">
              <Form.Field>
                <label>Área</label>
                <Dropdown
                  placeholder="Selecione a área"
                  selection
                  clearable
                  options={areasOptions}
                  value={filtroArea}
                  onChange={(e, { value }) => setFiltroArea(value)}
                />
              </Form.Field>
              <Form.Field>
                <label>Responsável</label>
                <Dropdown
                  placeholder="Selecione o responsável"
                  selection
                  search
                  clearable
                  options={responsaveisOptions}
                  value={filtroResponsavel}
                  onChange={(e, { value }) => setFiltroResponsavel(value)}
                />
              </Form.Field>
              <Form.Field>
                <label>Situação</label>
                <Dropdown
                  placeholder="Selecione a situação"
                  selection
                  clearable
                  options={situacoesOptions}
                  value={filtroSituacao}
                  onChange={(e, { value }) => setFiltroSituacao(value)}
                />
              </Form.Field>
              <Form.Field>
                <label>Parte (Nome)</label>
                <Form.Input
                  placeholder="Digite o nome da parte"
                  value={filtroParteNome}
                  onChange={(e) => setFiltroParteNome(e.target.value)}
                />
              </Form.Field>
              <Form.Field>
                <label>Regional</label>
                <Dropdown
                  placeholder="Selecione a regional"
                  selection
                  search
                  clearable
                  options={regionaisOptions}
                  value={filtroRegional}
                  onChange={(e, { value }) => setFiltroRegional(value)}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <label>Data de Abertura - De</label>
                <Form.Input
                  placeholder="YYYY-MM-DD"
                  type="date"
                  value={filtroDataAberturaInicio}
                  onChange={(e) => setFiltroDataAberturaInicio(e.target.value)}
                />
              </Form.Field>
              <Form.Field>
                <label>Data de Abertura - Até</label>
                <Form.Input
                  placeholder="YYYY-MM-DD"
                  type="date"
                  value={filtroDataAberturaFim}
                  onChange={(e) => setFiltroDataAberturaFim(e.target.value)}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group>
              <Form.Field>
                <Button primary onClick={buscar}>
                  <Icon name="search" /> Buscar
                </Button>
              </Form.Field>
              <Form.Field>
                <Button onClick={limpar}>
                  <Icon name="eraser" /> Limpar
                </Button>
              </Form.Field>
            </Form.Group>
          </Form>
        </Accordion.Content>
      </Accordion>

      {/* Loader global */}
      <Dimmer active={isLoading} inverted>
        <Loader>Aguarde...</Loader>
      </Dimmer>

      {/* Grid de Gráficos */}
      <Grid columns="equal" stackable>
        {/* Primeira linha: Situação, Área, Responsável */}
        <Grid.Row stretched className="grupo-graficos">
          <Grid.Column mobile={16} tablet={8} computer={4}>
            <Segment>
              <GraficoProcessosPorSituacao dados={totais.porSituacao} onExpandir={abrirExpandir} />
            </Segment>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={8} computer={4}>
            <Segment>
              <GraficoProcessosPorArea dados={totais.porArea} onExpandir={abrirExpandir} />
            </Segment>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <Segment>
              <GraficoProcessosPorResponsavel dados={totais.porResponsavel} onExpandir={abrirExpandir} />
            </Segment>
          </Grid.Column>
        </Grid.Row>

        {/* Segunda linha: Regional, Objeto e Mês */}
        <Grid.Row stretched className="grupo-graficos">
          <Grid.Column mobile={16} tablet={8} computer={4}>
            <Segment>
              <GraficoProcessosPorRegional dados={totais.porRegional} onExpandir={abrirExpandir} />
            </Segment>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={8} computer={6}>
            <Segment>
              <GraficoProcessosPorObjeto dados={totais.porObjeto} onExpandir={abrirExpandir} />
            </Segment>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={6}>
            <Segment>
              <GraficoProcessosPorMes dados={totais.porMes} onExpandir={abrirExpandir} />
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>

      {/* Tabela de Processos */}
      <Segment>
        <TabelaProcessos
          processos={processos}
          meta={meta}
          page={page}
          onPageChange={handlePageChange}
          isLoading={isLoading}
        />
      </Segment>

      {/* Modal Expandir Gráficos */}
      <Modal open={modalExpandirAberto} onClose={fecharExpandir} size="large">
        <Modal.Header>{tituloExpandir}</Modal.Header>
        <Modal.Content scrolling>
          <Table celled striped>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Descrição</Table.HeaderCell>
                <Table.HeaderCell textAlign="right">Quantidade</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {dadosExpandir.map((item, idx) => (
                <Table.Row key={idx}>
                  <Table.Cell>{item.label}</Table.Cell>
                  <Table.Cell textAlign="right">
                    <strong>{item.valor}</strong>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={fecharExpandir} primary>
            Fechar
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
}

export default Juridico;
